export function hasValidRole(userRole, comparedValue) {
  if (!userRole) return false;

  if (comparedValue instanceof Array) {
    return userRole.some(role => comparedValue.includes(role));
  }

  if (typeof comparedValue === "string") {
    return userRole.includes(comparedValue);
  }
}

export function isDynamicRole(userLogin, roleActive) {
  const userDynamic = userLogin.roles.find(user =>
    user.name.includes(roleActive)
  );
  return userDynamic.is_mutable;
}
